import { useMemo, useState } from 'react';

import { paginationDefaultValues } from './constants.ts';
import type { UsePaginationReturnType } from './types.ts';
import { PaginationDefaultValue } from './types.ts';

/**
 * Holds `page`/`perPage` state for a table. Note: when the data set changes such that the current
 * page no longer exists (e.g. a filter shrinks `total`), reset `page` to 0 via `setPage(0)`.
 * `usePageInfo` clamps the *displayed* range, but the prev/next disabled state reads `page` directly.
 */
export const usePagination = (limit?: PaginationDefaultValue): UsePaginationReturnType => {
  const [page, setPage] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(
    limit ? paginationDefaultValues[limit] : paginationDefaultValues[PaginationDefaultValue.LG],
  );

  return useMemo<UsePaginationReturnType>(
    () => ({
      page,
      setPage,
      perPage,
      setPerPage,
    }),
    [page, perPage],
  );
};
